const LabelPrinterIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="1em"
         height="1em"
         fill="currentColor">
        <path
            d="M14.9231 5.6922C14.9231 6.37194 14.3721 6.92297 13.6923 6.92297C13.0126 6.92297 12.4615 6.37194 12.4615 5.6922C12.4615 5.01247 13.0126 4.46143 13.6923 4.46143C14.3721 4.46143 14.9231 5.01247 14.9231 5.6922Z"
            fill="currentColor"
        />
        <path
            d="M6.0001 4.76917C5.49029 4.76917 5.07703 5.18244 5.07703 5.69225C5.07703 6.20204 5.49029 6.61532 6.0001 6.61532H9.69241C10.2023 6.61532 10.6154 6.20204 10.6154 5.69225C10.6154 5.18244 10.2023 4.76917 9.69241 4.76917H6.0001Z"
            fill="currentColor"
        />
        <path
            d="M8.15405 14.3076C8.15405 13.7978 8.56732 13.3845 9.07712 13.3845H10.9232C11.4331 13.3845 11.8464 13.7978 11.8464 14.3076C11.8464 14.8174 11.4331 15.2307 10.9232 15.2307H9.07712C8.56732 15.2307 8.15405 14.8174 8.15405 14.3076Z"
            fill="currentColor"
        />
        <path
            d="M9.07712 10.3076C8.56732 10.3076 8.15405 10.7209 8.15405 11.2308C8.15405 11.7405 8.56732 12.1538 9.07712 12.1538H10.9232C11.4331 12.1538 11.8464 11.7405 11.8464 11.2308C11.8464 10.7209 11.4331 10.3076 10.9232 10.3076H9.07712Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.923 14.9092V15.5385C14.923 16.898 13.821 18 12.4615 18H7.53845C6.17898 18 5.07692 16.898 5.07692 15.5385V14.9092C3.35185 14.7538 2 13.3039 2 11.5384V5.38461C2 3.51534 3.51534 2 5.38461 2H14.6154C16.4846 2 18 3.51534 18 5.38461V11.5384C18 13.3039 16.6481 14.7538 14.923 14.9092ZM5.38461 3.84615C4.53494 3.84615 3.84615 4.53495 3.84615 5.38461V11.5384C3.84615 12.2828 4.37469 12.9036 5.07692 13.0461V10C5.07692 8.64053 6.17898 7.53845 7.53845 7.53845H12.4615C13.821 7.53845 14.923 8.64053 14.923 10V13.0461C15.6253 12.9036 16.1538 12.2828 16.1538 11.5384V5.38461C16.1538 4.53495 15.465 3.84615 14.6154 3.84615H5.38461ZM7.53845 9.38461H12.4615C12.8013 9.38461 13.0769 9.66012 13.0769 10V15.5385C13.0769 15.8783 12.8013 16.1538 12.4615 16.1538H7.53845C7.19859 16.1538 6.92307 15.8783 6.92307 15.5385V10C6.92307 9.66012 7.19859 9.38461 7.53845 9.38461Z"
            fill="currentColor"
        />
    </svg>
);

export default LabelPrinterIcon;
